<template>
  <div class="manage-main-box">
    <Bread :breadConfig="breadConfig" />
    <div class="eol-container-box">

      <div class="search-all-box">
        <a-form-model layout="inline" ref="ruleForm" :model="form">
          <a-form-model-item prop="username">
            <a-input v-model="form.username" class="search-input" placeholder="请输入账号"></a-input>
          </a-form-model-item>
          <a-form-model-item prop="name">
            <a-input v-model="form.name" class="search-input" placeholder="请输入姓名"></a-input>
          </a-form-model-item>
          <a-form-model-item prop="mobile">
            <a-input v-model="form.mobile" class="search-input" placeholder="请输入手机号"></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-button class="search-btn" type="primary" @click="onSearch">搜索</a-button>
            <a-button class="reset-btn" @click="resetForm">重置</a-button>
          </a-form-model-item>
        </a-form-model>
        <div class="right-option-box">
          <a-button class="option-btn" type="primary" @click="handleModalVisible('showAddModal',true,1)">单个添加</a-button>
          <a-button class="option-btn" type="primary" @click="handleModalVisible('importVisible',true)">批量导入</a-button>
        </div>
      </div>

      <div class="table-all-box">
        <a-table :columns="columns" :data-source="tableData" rowKey="id" size="small" :pagination="false">
          <template slot="action" slot-scope="text,record">
            <a-button type="link" @click="handleModalVisible('showAddModal',true,2,record)">编辑</a-button>
            <a-button type="link" @click="handleModalVisible('showPasswordModal',true,null,record)">重置密码</a-button>
            <!-- <a-button type="link" @click="handleModalVisible('showDeleteModal',true,null,record.key)">删除</a-button> -->
          </template>
        </a-table>
        <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />
      </div>

    </div>
    <CommonModal v-model="showAddModal" :title="modalFlag == 1 ? '添加用户' : '编辑用户'" width="400px" @confirm="handleAddConfirm">
      <div class="a-form-style search-all-box">
        <a-form :form="addForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-form-item label="账号：">
            <a-input class="search-input" v-decorator="addRules.username" :disabled="modalFlag == 2" />
          </a-form-item>
          <a-form-item label="密码" v-if="modalFlag == 1">
            <div class="random-password">
              <div class="password">随机密码为：<span>{{ password }}</span></div>
              <div class="copy" @click="copyPassword(password)">复制密码</div>
            </div>
          </a-form-item>
          <a-form-item label="姓名">
            <a-input class="search-input" v-decorator="addRules.name" />
          </a-form-item>
          <a-form-item label="手机号">
            <a-input class="search-input" v-decorator="addRules.mobile" />
          </a-form-item>
        </a-form>
      </div>
    </CommonModal>
    <!-- <CommonModal v-model="showDeleteModal" title="删除用户" confirmText="确定" @confirm="handleDeleteConfirm">
      <div class="delete-modal">
        确定删除用户吗？
      </div>
    </CommonModal> -->
    <CommonModal v-model="showPasswordModal" title="重置密码" :showCancel="!passwordReset" confirmText="确定" @cancel="handlePasswordCancel" @confirm="handlePasswordConfirm">
      <div class="delete-modal">
        <div class="random-password" v-if="passwordReset">
          <div class="password">已重置密码为：<span>{{ password }}</span></div>
          <div class="copy" @click="copyPassword(password)">复制密码</div>
        </div>

        <p v-else>
          确定要重置密码吗？
        </p>

      </div>
    </CommonModal>
    <CommonModal v-model="importVisible" title="导入学员" @confirm="importConfirm()" @cancel="handleImportCancel()">
      <a-form-item :key=" fileKey">
        <!-- :showUploadList="false" -->
        <a-upload name="filename" :customRequest="customUpload" :multiple="false" accept=".xlsx,.xls" class="file-upload" :file-list="fileList" @change="handleChange">
          <div class="file-handle">
            <div class="file-name-box">{{uploadFilename ? uploadFilename : '请选择上传文件'}}</div>
            <a-button type='button' class="ant-btn ant-btn-primary">选择文件</a-button>
          </div>
        </a-upload>
      </a-form-item>
      <div class="tips">
        <div>* 请下载导入模板，将信息写入在此模板中导入 <span @click="downloadTemplate()">下载模板</span></div>
        <div>* 信息导入成功后，手机号即为该学生的账号</div>
        <div>* 设置账号的密码登录</div>
        <div class="search-all-box">
          <a-form :form="importForm" ref="importForm" style="width:100%">
            <div class="a-form-style">
              <a-form-item>
                <a-input v-decorator="passwordRules" placeholder="请输入密码" class="search-input"></a-input>
              </a-form-item>
            </div>
          </a-form>
        </div>

      </div>
    </CommonModal>

    <CommonModal v-model="resultVisible" title="导入学员" :cancel="importComplate" :footer="null" width="800px" :showConfirm="false" :showCancel="false">
      <div class="a-form-style">
        <!-- <div class="header-result">导入完成</div> -->
        <div class="result-tips">
          *共导入 {{ importResult.total_num }} 条数据，其中 {{ importResult.success_num }} 条导入成功。 {{ importResult.error_num }} 条导入失败。
        </div>
        <p class="result-text">失败数据：</p>
        <a-table :columns="resultColumns" :data-source="importResult.items" :pagination="false" :rowKey="(record, index) => { return index }">
          <div class="result-failed" slot="failed" slot-scope="row">
            {{ row }}
          </div>
        </a-table>
        <div style="padding-bottom: 40px;"></div>
      </div>

    </CommonModal>
    <!-- 下载进度 -->
    <a-spin :tip="`下载中 ${uploadProgress}% ...`" :spinning="loading">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>

  </div>
</template>
<script>
import Bread from "../../../../components/school/Bread.vue";
import CommonModal from "../../../../components/CommonModal"
import utils from "../../../../assets/js/utils"
// import axios from "axios";
import services from '../../../../assets/js/services';
import { mapActions } from "vuex";
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
export default {
  components: {
    Bread,
    CommonModal
  },
  data () {
    return {
      breadConfig: [{ name: "系统管理" }, { name: "学生管理" }],
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      form: {
        name: "",
        username: '',
        mobile: '',
      },
      columns: [
        {
          title: "账号",
          dataIndex: "username",
        },
        {
          title: "姓名",
          dataIndex: "name",
        },
        {
          title: "手机号",
          dataIndex: "mobile",
        },
        {
          title: "添加时间",
          dataIndex: "created_at",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
      showAddModal: false,
      showPasswordModal: false,
      passwordReset: false,
      addRules: {
        username: ['username', {
          validateTrigger: 'blur',
          rules: [
            { required: true, whitespace: true, message: '请输入账号' },
            { validator: this.checkUserName },
          ]
        }],
        name: ['name', {
          validateTrigger: 'blur',
          rules: [
            { required: true, whitespace: true, message: '请输入姓名' },
            {
              max: 50,
              whitespace: true,
              message: "姓名最长不能超过50字符",
            }
          ]
        }],
        mobile: ['mobile', {
          validateTrigger: "blur",
          initialValue: '',
          rules: [
            { validator: this.checkMobile, }
          ]
        }],
      },
      password: "",
      modalFlag: 1,// 1添加 2编辑
      rowKey: "",//选中的id
      importForm: this.$form.createForm(this, { name: 'importForm' }), // 初始化form表单
      importResult: {},
      passwordRules: ['password', {
        validateTrigger: "blur",
        rules: [
          { validator: this.checkPassword, }
        ]
      }],
      resultVisible: false,
      resultColumns: [ // 表格表头
        { title: '账号', dataIndex: 'username', width: "30%" },
        { title: '姓名', dataIndex: 'name', width: "15%", scopedSlots: { customRender: 'class_student' } },
        { title: '手机号', dataIndex: 'mobile', width: "20%", customRender: (text) => text || '-' },
        { title: '失败原因', dataIndex: 'error_message', scopedSlots: { customRender: 'failed' }, },
      ],
      uploadUrl: '', // 上传文件的url
      percent: 0,//上传进度
      uploadFilename: '', //上传的文件名称
      fileKey: Math.random(),
      importVisible: false, // 导入学员窗口
      limitSize: 1024 * 1024 * 100,
      uploadProgress: 0,
      loading: false,
      uploadPath: "",
      fileList: []
    };
  },
  watch: {
    showAddModal (val) {
      let that = this
      if (val) {
        that.$nextTick(() => {
          that.addForm.resetFields();
        });
      }
    },
  },
  beforeCreate () {
    this.addForm = this.$form.createForm(this);
  },
  mounted () {
    this.getTableList()
  },
  methods: {
    ...mapActions(["getSchoolStudent", "resetSchoolStudentPassword", "addSchoolStudent", "editSchoolStudent", "getSchoolStudentInfo", "getSchoolStudentSearch", "importSchoolStudent"]),
    handleImportCancel () {
      this.fileList = []
      this.uploadFilename = ""
      this.importForm.resetFields()
    },
    handleChange (info) {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      this.fileList = fileList;
      if (this.fileList.length == 0) this.uploadFilename = ""
    },
    getTableList () {
      let params = {
        page: this.page,
        size: this.size,
        username: this.form.username,
        name: this.form.name,
        mobile: this.form.mobile,
      };
      this.getSchoolStudent(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
        }
      });
    },
    onSearch () {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    pageChange (val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    resetForm () {
      this.$refs.ruleForm.resetFields();
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    // 校验手机号
    checkMobile (rule, value, callback) {
      const reg = /^1[0-9]{10}$/
      if (rule && value) {
        if (reg.test(value)) {
          return callback();
        } else {
          return callback(new Error('请填写正确的手机号'));
        }
      } else {
        return callback();
      }
    },
    // 获取当前编辑用户的信息
    userDetails (id) {
      let that = this
      this.getSchoolStudentInfo({ id: id }).then(res => {
        if (res.code == '0000') {
          that.$nextTick(() => {
            setTimeout(() => {
              that.addForm.setFieldsValue({
                username: res.data.username,
                name: res.data.name,
                mobile: res.data.mobile,
              })
            }, 200);
          })
        }
      })
    },
    handleModalVisible (key, val, flag, rowKey) {
      let that = this
      this.rowKey = rowKey
      this[key] = val
      if (key == 'showAddModal' && val) {
        this.modalFlag = flag
        if (flag == 1) {
          that.password = utils.randomPassword()
        } else if (flag == 2) {
          that.userDetails(rowKey.id)
        }
      }


    },
    // 校验密码
    checkPassword (rule, value, callback) {
      const reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,16}$/;
      if (rule && value) {
        if (!reg.test(value)) {
          callback(new Error('请输入【8-16】位，由大小写字母及数字组成的密码'))
        }
        else {
          callback()
        }
      } else {
        callback(new Error('请输入密码'))
      }

    },
    // 校验账号
    checkUserName (rule, value, callback) {
      const reg = /^[a-zA-Z0-9_]{6,16}$/;
      if (rule && value) {
        if (reg.test(value)) {
          return callback();
        } else {
          return callback(new Error('请输入【6-16】位，由数字或字母组成的账号'));
        }
      }
      else {
        return callback();
      }
    },
    // 复制随机密码
    copyPassword (context) {
      let inputElement = document.createElement('input')
      inputElement.value = context
      document.body.appendChild(inputElement)
      inputElement.select()
      document.execCommand('Copy')
      inputElement.remove()
      this.$message.success("复制成功")
    },
    // 添加、编辑用户方法
    async requestUserOperate (type, params) {
      let that = this
      await services[type == 1 ? "addSchoolStudent" : "editSchoolStudent"](params).then(res => {
        if (res.code == "0000") {
          that.$message.success(`${type == 1 ? '添加' : type == 2 ? '编辑' : '删除'}成功`)
          that.getTableList()
        } else {
          that.$message.error(res.message)
        }
      })
    },
    // 编辑添加用户 - 确认 提交表单事件
    handleAddConfirm () {
      let that = this
      this.addForm.validateFields((err, values) => {
        if (!err) {
          if (that.modalFlag == 1) {
            let data = { ...values, password: this.password, role_ids: 2 }
            if (that.userExistId) data.id = that.userExistId
            that.requestUserOperate(that.modalFlag, data)
          } else {
            that.requestUserOperate(that.modalFlag, { id: that.rowKey.id, data: { ...values, _method: 'put' } })
          }

          that.handleModalVisible("showAddModal", false)
        }
      });
    },
    // 重置密码 - 确认按钮事件
    handlePasswordConfirm () {
      let that = this
      if (that.passwordReset) {
        that.handleModalVisible("showPasswordModal", false)
        that.handlePasswordCancel()
      } else {
        that.resetSchoolStudentPassword({ id: that.rowKey.id, _method: 'put' }).then(res => {
          if (res.code == "0000") {
            that.password = res.data
            that.passwordReset = true
            that.$message.success(`重置密码成功`)
          } else {
            that.$message.error(res.message)
          }
        })
      }
    },
    handlePasswordCancel () {
      let that = this
      let timer = setTimeout(function () {
        that.passwordReset = false
        that.password = ''
        clearTimeout(timer)
      }, 500)
    },

    // 自定义上传事件
    customUpload (info) {
      let that = this
      const uploadApi = ({ file, onUploadProgress }) => {
        that.uploadFilename = file.name
        const formData = new FormData();
        formData.append('file', file);
        formData.append('is_tmp', 1);
        formData.append('uuid', uuidv4());
        formData.append('label', 'student');

        return axios({
          url: `${services.HOST}/api/upload/file`,
          method: 'POST',
          data: formData,
          headers: {
            'Content-type': 'multipart/form-data',
          },
          onUploadProgress, // 上传进度回调函数 
        })
      }
      uploadApi({
        file: info.file,
        onUploadProgress: (ev) => {
          that.percent = parseInt((ev.loaded / ev.total) * 100);
          info.onProgress({ percent: that.percent });
        },
      }).then((res) => {
        that.percent = 0
        info.onSuccess(res.data, info);
        if (res.data.code == '0000') {
          that.uploadPath = res.data.data.path
          that.$message.success(`${res.data.data.filename}上传成功`)
        } else {
          that.$message.error("上传失败")
        }
      }).catch((err) => {
        info.onError(err);
      });
    },

    // 导入学员窗口确认
    importConfirm () {
      this.importForm.validateFields(async (err, values) => {
        if (!err) {
          try {
            let result = await this.importSchoolStudent({ path: this.uploadPath, password: values.password })
            if (result.code == "0000") {
              this.$message.success("导入完成");
              this.importResult = result.data
              this.importForm.resetFields(); // 重置表单
              this.importVisible = false
              this.resultVisible = true
              this.fileKey = Math.random()
              this.fileList = []
              this.uploadFilename = ""
            } else {
              this.$message.error(result.message)
            }
          } catch (err) {
            console.log(err);
            this.$message.error("导入失败")
          }

        } else {
          console.log(err);
        }
      });

    },
    // 导入完成后 点击确定
    importComplate () {
      this.resultVisible = false
      this.uploadFilename = ''
      this.resetSearch()
    },
    // 导入学员模板下载
    async downloadTemplate () {
      let url = services.HOST + `/template/账号导入模板.xlsx`
      window.open(url)
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none'; // 隐藏iframe
      iframe.style.height = 0; // 设置高度为0以避免影响布局
      iframe.src = url; // 设置下载链接
      document.body.appendChild(iframe); // 将iframe添加到DOM树中
      // 由于onload方法对于下载链接不起作用，使用延时清除iframe标签
      iframe.remove(); // 在一段时间后移除iframe，通常设置为一个较大的值以确保下载完成
    },

    // 文件流处理
    createUrlBlob (url, fileName, type) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.setAttribute('download', `${fileName}.${type}`);
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
      a.remove()
    },

  },
};
</script>

<style lang="less" scoped>
.a-form-style {
    .ant-form {
        width: 100%;
    }
    .ant-form-item {
        margin-bottom: 10px;
    }
}

.file-handle {
    display: flex;
    align-items: center;
    position: relative;
}
.tips {
    text-align: left;
}
.tips div {
    color: #f73b3b;
    margin-top: 10px;
}
.tips span {
    color: #125cfb;
    cursor: pointer;
}

.file-name-box {
    display: inline-block;
    width: 250px;
    height: 32px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 32px;
    color: #606266;
    padding-left: 10px;
    cursor: pointer;
    position: relative;
    z-index: 1;
}
.file-name-input {
    display: inline-block;
    width: 100%;
    height: 32px;
    opacity: 0;
    position: absolute;
    z-index: 10;
}
/deep/ .ant-progress-bg {
    background: #9c211b;
}
/deep/.ant-upload-list-item:hover .ant-upload-list-item-info {
    background: rgba(156, 33, 27, 0.3);
    color: #fff;
}
.file-handle button {
    margin-left: 15px;
    background: #9c211b;
    border: none;
    outline: none;
    &::after {
        display: none;
    }
}
.header-result {
    text-align: center;
    margin: 5px 0 10px;
    font-size: 18px;
    font-weight: 700;
    color: #000;
}
.result-tips {
    color: #f73b3b;
    text-align: center;
    margin-bottom: 5px;
    padding-top: 35px;
}
.result-text {
    color: #000;
    margin-bottom: 5px;
}
.result-failed {
    color: #f73b3b;
    white-space: nowrap;
}
.flex-left {
    flex-wrap: wrap;
}
</style>